export function sendMetric(name, value, accessToken) {
  // Only send 20% of the time
  if (Math.random() > 0.8) return

  requestAnimationFrame(() => {
    const url = `/2018-02-13/sessions/${accessToken}/client-metrics`

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ [name]: value })
    })
  })
}
